module.exports = __webpack_public_path__ + "img/qrCode.3a6663cc.png";